/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  IProfileOutputUser,
  IProfileOutputMetrics,
  IProfileOutputOutboundWebhooksManagementUrl,
  IProfileOutputAPIKey,
  IProfileOutputGoogleDriveAccessTokenInfo,
  IGenericJSONMessage,
} from '../types/response.types'

export default new class ProfileAPI extends RequestHandler {
  /****** GET methods *****/
  public async get_Index(
  ): Promise<IProfileOutputUser> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/profile`,
    })
  }
  public async get_Metrics(
  ): Promise<IProfileOutputMetrics> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/profile/metrics`,
    })
  }
  public async get_OutboundWebhooksManagementUrl(
  ): Promise<IProfileOutputOutboundWebhooksManagementUrl> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/profile/outbound-webhooks-management-url`,
    })
  }
  public async get_APIKey(
  ): Promise<IProfileOutputAPIKey> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/profile/api-key`,
    })
  }
  public async get_GoogleDriveAuth(
    from_url: string,
  ): Promise<IProfileOutputGoogleDriveAccessTokenInfo> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/profile/google-drive-auth`,
      params: {
        from_url,
      },
    })
  }
  /****** DELETE methods *****/
  public async delete_RevokeGoogleDriveAuth(
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/profile/google-drive-auth/revoke`,
    })
  }
}()
